const cookieConfig = () => {
  const isDev = ENV === 'dev';
  const domain = isDev ? 'localhost' : 'resy.com';
  const path = '/';
  const secure = true;
  const sameSite = 'strict';

  return {
    domain,
    path,
    sameSite,
    secure,
  };
};

export default cookieConfig;
